import "./style.scss";
import { Dispatch, FC, SetStateAction, useState } from "react";
import { useDispatch } from "react-redux";
import { onlineApplicationsStarsConst } from "@/src/constants/applicationOnlineConsts";
import { setFilterStatus, updateFilterResult } from "@/src/store/slices/OfficeAccountingPage/officeAccountingFiltersSlice";
import { IFiltersList } from "@/src/types/applicationOnline";
import ApplicationStarIcon from "@/src/components/ApplicationsPage/ApplicationStarIcon";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";

interface IOAPFilterPopUp {
  id: string;
  tableFiltersList: IFiltersList | undefined;
  filterPopUp: string | null;
  setFilterPopUp: Dispatch<SetStateAction<string | null>>;
}

const OAPFilterPopUp: FC<IOAPFilterPopUp> = ({ id, tableFiltersList, filterPopUp, setFilterPopUp }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<string[]>([]);

  const toStringArray = (value: unknown): string[] => {
    if (!Array.isArray(value)) return [];
    return value.map((item) => String(item));
  };

  const handleEventToggle = (value: string) => {
    setSelected((prev) => (prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]));
  };

  const handleEventChooseAll = () => {
    if (id === "color_star") {
      const fromList = toStringArray(tableFiltersList?.color_star);
      setSelected(fromList.length > 0 ? fromList : onlineApplicationsStarsConst.map((star) => star.color));
      return;
    }
    setSelected([]);
  };

  const handleEventClearFilters = () => setSelected([]);

  const handleApply = () => {
    dispatch(setFilterStatus("All"));
    const isAllStarsSelected = id === "color_star" && selected.length === onlineApplicationsStarsConst.length;
    dispatch(updateFilterResult({ key: id, value: selected.length > 0 && !isAllStarsSelected ? selected : null }));
    setFilterPopUp(null);
  };

  if (id !== "color_star") return null;

  return (
    <div className={`office-accounting-page-filter ${id === filterPopUp ? "show" : ""}`}>
      <div className="office-accounting-page-filter-title">
        <p>Star</p>
      </div>
      <ul className="office-accounting-page-filter-ul">
        {onlineApplicationsStarsConst.map(({ color }) => (
          <li className="office-accounting-page-filter-li" key={color}>
            <label className="office-accounting-page-filter-li-label">
              <input type="checkbox" checked={selected.includes(color)} onChange={() => handleEventToggle(color)} />
              <span className="checkmark" />
            </label>
            <ApplicationStarIcon color={color} />
          </li>
        ))}
      </ul>
      <div className="office-accounting-page-filter-actions">
        <button type="button" onClick={handleEventChooseAll}>
          Choose all
        </button>
        <button type="button" onClick={handleEventClearFilters}>
          Clear filters
        </button>
      </div>
      <div className="office-accounting-page-filter-buttons">
        <BtnDefault onClick={handleApply}>
          <p>Ok</p>
        </BtnDefault>
        <BtnDefault onClick={() => setFilterPopUp(null)}>
          <p>Cancel</p>
        </BtnDefault>
      </div>
    </div>
  );
};

export default OAPFilterPopUp;
